<template>
  <van-nav-bar
    :title="title"
    :left-text="leftText"
    :left-arrow="isShowLeftBtn"
    :fixed="true"
    @click-left="onClickLeft"
  >
    <template #right >
      <div class="rightOpr">
        <!--add-->
        <span v-show="isShowRightBtn('add')" @click="onClickRight" class="svg-container">
          <svg-icon icon-class="create"/>
        </span>
        <span @click="onClickRight">{{rightText}}</span>
      </div>
    </template>
  </van-nav-bar>
</template>

<script>
export default {
  name: 'AppHeader',
  props: {
    leftText: {
      type: String,
      default: ''
    },
    rightText: {
      type: String,
      default: ''
    },
    showLeft: {
      type: Boolean,
      default: true
    },
    dynamicTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      route: ''
    };
  },
  mounted() {
  },
  computed: {
    meta() {
      return this.$route.meta;
    },
    title() {
      const routerTitle = this.$route.meta.title;
      if (routerTitle) {
        return routerTitle;
      } else {
        return this.dynamicTitle;
      }
    },
    isShowRightBtn() {
      return function(opr) {
        return this.$route.meta.rightOpr === opr;
      };
    },
    backMenu() {
      return this.$route.meta.backUrl;
    },
    isShowLeftBtn() {
      let isShow = true;
      if (this.meta.showHeader === false) {
        isShow = this.showLeft;
      } else {
        isShow = this.meta.showLeft !== false;
      }
      return isShow;
    }
  },
  methods: {
    // 返回
    onClickLeft() {
      // 使用自己的头部返回
      if (this.$listeners['handleLeftFn']) {
        // 如果有提供执行$emit这里
        this.$emit('handleLeftFn');
      } else if (this.backMenu) {
        this.$router.push(this.backMenu);
      } else {
        this.$router.go(-1);
      }
    },
    // 右侧操作
    onClickRight() {
      if (this.meta.rightUrl) {
        this.$router.push(this.meta.rightUrl);
      } else {
        this.$emit('handleRightFn');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.rightOpr {
  margin-right: 5px;
  color: #334EB4;
}
.svg-container {
  color: #334EB4;
  vertical-align: middle;
  display: inline-block;
  .svg-icon {
    width: 20px;
    height: 20px;
  }
}
</style>
